import { wrapNavigatorScreen } from '@psl/functions/navigation/utils/wrapNavigatorScreen';
import { lazy } from 'react';

const PromptScreenContent = lazy(() => import('./PromptScreen.content'));

export const PromptScreen = wrapNavigatorScreen(PromptScreenContent, {
  headerShown: false,
  animationEnabled: false,
  cardStyle: { backgroundColor: 'transparent' },
  presentation: 'transparentModal',
});
